import { Pipe, PipeTransform } from '@angular/core';

const caratteriSpeciali = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

@Pipe({
  name: 'removeTextBetweenCharacters'
})

export class RemoveTextBetweenCharactersPipe implements PipeTransform {

  /** Rimuove il testo tra due caratteri (compresi quest'ultimi) */
  transform(value: unknown, ...args: any) {
    

    //console.warn(value,args);

    if(!value || ( !args[0][0] && ! args[0][1]))
      return null;

    let carattereIniziale = args[0][0];
    let carattereFinale = args[0][1];

    //(value as string).replace("/(?=${caratteriSpeciali.test(carattereIniziale) ? '[' + caratteriSpeciali.test(carattereIniziale)+ ']' : carattereIniziale }).*?(?<=${caratteriSpeciali.test(carattereFinale) ? '[' + caratteriSpeciali.test(carattereFinale)+ ']' : carattereFinale })/g",""); 

    let regExp : RegExp;
    
    if(carattereIniziale && carattereFinale)
      regExp = new RegExp("(?=[" + carattereIniziale + "]).*?(?<=[" +  carattereFinale +"])","g");
    else if(carattereIniziale && !carattereFinale)
      regExp = new RegExp("(?=[" + carattereIniziale + "]).*","g");
    else if(!carattereIniziale && carattereFinale)
      regExp = new RegExp("(?=[" + carattereIniziale + "]).*","g");


    let ris = (value as string).replace(regExp as RegExp,"").trim(); ///(?=[(]).*?(?<=[)])/g

    return ris;
    
      
  }

}
